(ns ui.social-account.connect-modal
  "Modal for choosing which social account type to connect."
  (:require [app.bundle-social.page :as social-accounts-page]
            [app.bundle-social.platforms :as social-platforms]
            [app.client-log :as client-log]
            [parts.replicant.query :as query]))

(def tiktok-query
  {:query/kind :query/tiktok})

(def youtube-query
  {:query/kind :query/youtube})

(defn- instagram-icon
  [classes]
  [:svg {:xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 448 512"
         :fill "currentColor"
         :aria-hidden "true"
         :class classes}
   [:path {:d "M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"}]])

(defn- tiktok-icon
  [classes]
  [:svg {:xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 448 512"
         :fill "currentColor"
         :aria-hidden "true"
         :class classes}
   [:path {:d "M448 209.9a210.1 210.1 0 01-122.8-39.3v178.8A162.6 162.6 0 11185 188.3v89.9a74.6 74.6 0 1052.2 71.2V0h88a121 121 0 00122.8 121.1z"}]])

(defn- youtube-icon
  [classes]
  [:svg {:xmlns "http://www.w3.org/2000/svg"
         :viewBox "0 0 576 512"
         :fill "currentColor"
         :aria-hidden "true"
         :class classes}
   [:path {:d "M549.7 124.1c-6.3-23.7-24.8-42.3-48.3-48.6C458.8 64 288 64 288 64S117.2 64 74.6 75.5c-23.5 6.3-42 24.9-48.3 48.6C15 167 15 256.4 15 256.4s0 89.4 11.3 132.3c6.3 23.7 24.8 41.5 48.3 47.8C117.2 448 288 448 288 448s170.8 0 213.4-11.5c23.5-6.3 42-24.1 48.3-47.8C561 345.8 561 256.4 561 256.4s0-89.4-11.3-132.3zM232 337.6V175.2l142 81.2-142 81.2z"}]])

(def platforms
  [{:id :instagram
    :name "Instagram"
    :eyebrow "Stories & Reels"
    :description "Schedule and publish Instagram stories and reels."
    :button-text "Connect Instagram"
    :icon instagram-icon
    :style {:card-class ["border-pink-200" "bg-gradient-to-br" "from-purple-50"
                         "via-pink-50" "to-orange-50" "hover:border-pink-300"]
            :eyebrow-class ["bg-white/70" "text-pink-600" "ring-pink-100"]
            :icon-class ["bg-white" "text-pink-500" "ring-pink-200"]
            :title-class ["text-gray-900"]
            :description-class ["text-gray-600"]
            :button-class ["bg-gradient-to-r" "from-purple-500" "via-pink-500"
                           "to-orange-400" "text-white" "hover:from-purple-600"
                           "hover:via-pink-600" "hover:to-orange-500"]}
    :action [[:ui/modal-close]
             [:connect3-info/open {}]]}
   {:id :tiktok
    ;; The post limit of bundle.social, which replaces the own
    ;; integration.
    :platform-id "TIKTOK"
    :name "TikTok"
    :eyebrow "Video & image posts"
    :description "Connect TikTok for scheduled video and image posts."
    :button-text "Connect TikTok"
    :icon tiktok-icon
    :style {:card-class ["border-gray-900" "bg-gray-950" "hover:border-cyan-300"]
            :eyebrow-class ["bg-white/10" "text-cyan-200" "ring-cyan-300/30"]
            :icon-class ["bg-black" "text-white" "ring-cyan-300/60"]
            :title-class ["text-white"]
            :description-class ["text-gray-300"]
            :button-class ["bg-white" "text-gray-950" "hover:bg-gray-100"]}}
   {:id :youtube
    :platform-id "YOUTUBE"
    :name "YouTube"
    :eyebrow "Shorts"
    :description "Connect YouTube for scheduled Shorts uploads."
    :button-text "Connect YouTube"
    :icon youtube-icon
    :style {:card-class ["border-red-200" "bg-red-50" "hover:border-red-300"]
            :eyebrow-class ["bg-white/70" "text-red-600" "ring-red-100"]
            :icon-class ["bg-white" "text-red-600" "ring-red-200"]
            :title-class ["text-gray-900"]
            :description-class ["text-gray-600"]
            :button-class ["bg-red-600" "text-white" "hover:bg-red-700"]}}])

(defn social-platform-card
  "The card of a launched bundle.social platform, from its
   `:social-platform/connect-card`. Its button starts the platform's
   connect flow (`app.bundle-social.register`)."
  [platform]
  (let [id (:social-platform/id platform)
        card (:social-platform/connect-card platform)]
    (assoc card
           :id (:social-platform/key platform)
           :platform-id id
           :name (:social-platform/name platform)
           :icon (:social-platform/icon platform)
           :action [[:client-log/log :onboarding/connect-platform-chosen
                     {:connect/platform (name (:social-platform/key platform))}]
                    [:social-accounts/connect id]])))

(defn all-platforms
  []
  (into platforms
        (map social-platform-card)
        (social-platforms/launched)))

(defn- card-accent
  [platform-id]
  (case platform-id
    :instagram
    [:div.pointer-events-none.absolute.-right-10.-top-10.h-28.w-28.rounded-full.bg-pink-200.opacity-40.blur-2xl]

    :tiktok
    [:div.pointer-events-none.absolute.inset-0
     [:div.absolute.-right-8.-top-8.h-24.w-24.rounded-full.bg-cyan-400.opacity-20.blur-2xl]
     [:div.absolute.-left-8.-bottom-8.h-24.w-24.rounded-full.bg-red-500.opacity-20.blur-2xl]]

    :youtube
    [:div.pointer-events-none.absolute.-right-10.-top-10.h-28.w-28.rounded-full.bg-red-200.opacity-40.blur-2xl]

    nil))

(defn- card-class
  [style disabled?]
  (concat ["relative" "flex" "h-full" "overflow-hidden" "rounded-2xl" "border"
           "p-5" "shadow-sm" "transition-all" "duration-200"]
          (:card-class style)
          (if disabled?
            ["opacity-70"]
            ["hover:-translate-y-0.5" "hover:shadow-md"])))

(def base-button-class
  ["mt-5" "inline-flex" "items-center" "justify-center" "rounded-lg" "px-4"
   "py-2.5" "text-sm" "font-semibold" "shadow-sm" "transition-colors"])

(defn- action-attrs
  [{:keys [action style]}]
  {:type "button"
   :class (concat base-button-class
                  ["cursor-pointer"]
                  (get-in style [:button-class]))
   :on {:click action}})

(defn- link-attrs
  [href style]
  {:href href
   :class (concat base-button-class
                  (get-in style [:button-class]))})

(defn- disabled-attrs
  []
  {:type "button"
   :disabled true
   :class (concat base-button-class
                  ["bg-gray-200" "text-gray-500" "cursor-not-allowed"])})

(defn instagram-connect-action
  [modal-params]
  [[:client-log/log :onboarding/connect-platform-chosen
    {:connect/platform "instagram"}]
   [:ui/modal-close]
   ;; `:source` travels into the connect3 URL, see
   ;; storrito.connect3.info-panel/connect-query.
   (if (:skip-instagram-info? modal-params)
     [:connect3-info/continue (select-keys modal-params [:source])]
     [:connect3-info/open (select-keys modal-params [:source])])])

(defn- post-limit
  "\"Up to 50 posts per day per account\" under the description of a
   card with a `:platform-id` (bundle.social's platforms, and TikTok and
   YouTube, whose own integrations bundle.social replaces), once the
   limits are loaded."
  [platform style post-limits]
  (when-let [n (get post-limits (:platform-id platform))]
    [:p
     {:class (concat ["mt-2" "text-xs" "font-medium"]
                     (:description-class style))}
     (str "Up to " n (if (= 1 n) " post" " posts") " per day per account")]))

(defn- platform-card
  [platform {:keys [authorize-urls modal-params connecting? post-limits]}]
  (let [platform (cond-> platform
                   (= :instagram (:id platform))
                   (assoc :action (instagram-connect-action modal-params)))
        style (:style platform)
        icon (:icon platform)
        authorize-url (get authorize-urls (:id platform))
        disabled? (and (not (:action platform))
                       (not authorize-url))]
    [:div
     {:class (card-class style disabled?)
      :replicant/key (:id platform)}
     (card-accent (:id platform))
     [:div.relative.z-10.flex.flex-col.h-full.w-full
      [:div.flex.items-center.justify-between.gap-3
       [:div
        {:class (concat ["flex" "h-12" "w-12" "items-center" "justify-center"
                         "rounded-xl" "ring-1" "shadow-sm"]
                        (:icon-class style))}
        (icon ["h-6" "w-6"])]
       [:span
        {:class (concat ["inline-flex" "items-center" "rounded-full" "px-2.5"
                         "py-1" "text-xs" "font-semibold" "ring-1"]
                        (:eyebrow-class style))}
        (:eyebrow platform)]]
      [:h3
       {:class (concat ["mt-4" "text-lg" "font-semibold"]
                       (:title-class style))}
       (:name platform)]
      [:p
       {:class (concat ["mt-2" "text-sm" "leading-6" "grow"]
                       (:description-class style))}
       (:description platform)]
      (post-limit platform style post-limits)
      (cond
        ;; A bundle.social card waits for its OAuth url. Instagram's
        ;; action only opens the connect3 panel, it is never "opening".
        (and (:action platform) connecting? (not= :instagram (:id platform)))
        [:button (disabled-attrs)
         "Opening…"]

        (:action platform)
        [:button (action-attrs platform)
         (:button-text platform)]

        authorize-url
        ;; The click navigates to the external OAuth page; the log
        ;; action still goes through thanks to fetch keepalive.
        [:a (assoc (link-attrs authorize-url style)
                   :on {:click [[:client-log/log
                                 :onboarding/connect-platform-chosen
                                 {:connect/platform (name (:id platform))}]]})
         (:button-text platform)]

        :else
        [:button (disabled-attrs)
         "Preparing…"])]]))

(defn platform-grid
  "The platform connect cards. Shared between the connect modal
   and pages that show an inline connect prompt (e.g. the scheduling
   page without any connected account). The TikTok/YouTube cards need
   the `tiktok-query`/`youtube-query` results in the state for their
   authorize URLs, and `social-accounts-page/post-limits-query` for the
   posts per day of the other cards - load these queries wherever this
   is rendered."
  [state]
  (let [tiktok-result (query/get-result state tiktok-query)
        youtube-result (query/get-result state youtube-query)
        authorize-urls {:tiktok (:tiktok/authorize-url tiktok-result)
                        :youtube (:youtube/authorize-url youtube-result)}
        post-limits (:social-accounts/post-limits
                      (query/get-result state social-accounts-page/post-limits-query))
        modal-params (get-in state [:ui/modal :params])]
    [:div
     {:class ["grid" "gap-4" "sm:grid-cols-2" "lg:grid-cols-3"]}
     (map #(platform-card % {:authorize-urls authorize-urls
                             :modal-params modal-params
                             :post-limits post-limits
                             :connecting? (social-accounts-page/connecting? state)})
          (all-platforms))]))

(defn render
  [state]
  [:div
   ;; Funnel step: the platform chooser was opened (the gap between
   ;; "App Loaded" and the Instagram-only "Open Connect").
   {:replicant/on-mount (fn [_]
                          (client-log/log! :onboarding/connect-modal-opened))}
   [:div
    {:class ["text-center" "mb-6"]}
    [:h2
     {:class ["text-2xl" "font-bold" "text-gray-900"]}
     "Add social account"]
    [:p
     {:class ["mt-2" "text-sm" "text-gray-500"]}
     "Choose the platform you want to connect to Storrito."]]
   (platform-grid state)])

(def modal
  {:modal-id :modals/social-account-connect
   :on-load (fn [_state]
              [[:data/query tiktok-query]
               [:data/query youtube-query]
               [:data/query social-accounts-page/post-limits-query]])
   :render #'render})
